import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SeoHead from '@/components/feature/SeoHead';

const faqs = [
  {
    q: '九游娱乐是什么平台？',
    a: '九游娱乐是值得信赖的综合游戏娱乐平台，汇聚海量精品游戏，涵盖电子游艺、真人视讯、体育电竞、棋牌捕鱼等多元品类，为玩家提供安全、稳定、公平的游戏环境。平台拥有800万+注册用户，2000+款精品游戏。',
  },
  {
    q: '九游娱乐是否合法正规？',
    a: '九游娱乐持有正规运营牌照，严格遵守国际线上游戏管理规范。平台所有游戏结果均由国际认证的随机数生成器（RNG）决定，确保公正公平。我们采用银行级数据加密技术保护用户信息和资金安全。',
  },
  {
    q: '如何注册九游娱乐账号？',
    a: '注册流程非常简单：访问九游娱乐官网，点击右上角"立即注册"按钮，填写基本信息（用户名、密码、手机号），完成手机验证即可。整个注册过程仅需约1分钟。注册后即可享受新人首存豪礼。',
  },
  {
    q: '提现需要多长时间？',
    a: '九游娱乐支持快捷提现服务，工作日提现通常在30分钟内到账，节假日提现最长不超过2小时。VIP会员享有优先提现通道和更高提现额度。我们支持多种提现方式，方便快捷。',
  },
  {
    q: '客服联系方式是什么？',
    a: '九游娱乐提供7×24小时全天候客服支持，您可以通过以下方式联系我们：客服热线 400-888-9999、在线客服（官网右下角）、官方邮箱 service@jiuyou.com。我们承诺在3分钟内响应您的咨询。',
  },
  {
    q: '九游娱乐支持哪些设备？',
    a: '九游娱乐支持全平台使用，包括PC电脑端（Windows/Mac）、手机端（iOS/Android APP）和平板设备。所有平台数据实时同步，您可以随时随地畅享游戏乐趣。移动端APP优化的流量消耗和电池续航，体验流畅。',
  },
];

const milestones = [
  { year: '2018', title: '平台成立', desc: '九游娱乐正式成立，首期上线200款游戏' },
  { year: '2019', title: '用户突破', desc: '注册用户突破100万，真人视讯板块上线' },
  { year: '2020', title: '移动端发布', desc: 'iOS和Android APP正式发布，移动端用户快速增长' },
  { year: '2021', title: '游戏突破', desc: '平台游戏总数突破1000款，引入体育电竞板块' },
  { year: '2022', title: '行业标杆', desc: '注册用户突破500万，荣获多项行业大奖' },
  { year: '2023', title: '全球布局', desc: '启动国际化战略，服务覆盖东南亚多国市场' },
  { year: '2024', title: '持续领先', desc: '注册用户突破800万，持续引领行业创新' },
];

export default function AboutPage() {
  return (
    <main>
      <SeoHead
        title="关于九游娱乐 - 品牌介绍 | 信誉保障 | 联系我们"
        description="九游娱乐成立于2018年，是值得信赖的综合游戏娱乐平台。了解九游娱乐的品牌故事、发展历程、信誉保障和联系方式。800万+用户的选择。"
        keywords="九游娱乐,关于九游娱乐,九游娱乐品牌,九游娱乐信誉,九游娱乐联系方式"
        canonicalUrl="https://www.jiuyou.com/about"
        schemaType="Organization"
      />
      <Navbar />

      <div className="pt-16 md:pt-18">
        <div className="w-full bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 lg:px-8 py-8 md:py-10">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-4" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.jiuyou.com/' },
                    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.jiuyou.com/about' },
                  ],
                }),
              }}
            />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">关于九游娱乐</h1>
            <p className="text-foreground-600 text-sm">值得信赖的综合游戏娱乐平台</p>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">品牌介绍</h2>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                  九游娱乐成立于2018年，是一家专注于<strong>在线游戏娱乐</strong>的综合服务平台。
                  自创立以来，我们始终秉持<strong>"以玩家为中心"</strong>的核心理念，
                  致力于为全球玩家打造安全、公平、高品质的游戏娱乐体验。
                </p>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
                  经过多年的深耕发展，九游娱乐已成长为行业领先的游戏娱乐平台，
                  拥有<strong>800万+注册用户</strong>和<strong>2000+款精品游戏</strong>。
                  平台涵盖电子游艺、真人视讯、体育电竞、彩票游戏、捕鱼游戏、棋牌游戏、街机游戏等多元品类，
                  满足不同玩家的娱乐需求。
                </p>
                <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                  九游娱乐以<strong>安全稳定</strong>为基石，采用国际领先的数据加密和风险控制技术，
                  确保每一位玩家的信息和资金安全。我们获得了多项国际权威认证，
                  是玩家值得信赖的长期合作伙伴。
                </p>
              </div>
              <div className="relative rounded-xl overflow-hidden h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20modern%20corporate%20headquarters%20building%20with%20warm%20golden%20lighting%2C%20dark%20elegant%20architecture%2C%20luxurious%20lobby%20interior%2C%20premium%20business%20atmosphere%2C%20corporate%20photography%20style&width=800&height=600&seq=about-brand&orientation=landscape"
                  alt="九游娱乐品牌形象"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">发展历程</h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 -translate-x-1/2 hidden md:block"></div>
              <div className="flex flex-col gap-6">
                {milestones.map((item, i) => (
                  <div key={item.year} className={`flex flex-col md:flex-row gap-4 md:gap-8 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} hidden md:block`}>
                      {i % 2 === 0 ? (
                        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
                          <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{item.title}</h3>
                          <p className="text-foreground-600 text-xs">{item.desc}</p>
                        </div>
                      ) : null}
                    </div>
                    <div className="flex items-center gap-4 md:gap-0 md:justify-center">
                      <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center md:order-1 flex-shrink-0">
                        <div className="w-2 h-2 rounded-full bg-background-50"></div>
                      </div>
                      <span className="font-heading font-bold text-primary-600 text-sm md:hidden">{item.year}</span>
                    </div>
                    <div className={`flex-1 ${i % 2 !== 0 ? 'md:text-left' : 'md:text-right'} hidden md:block`}>
                      {i % 2 !== 0 ? (
                        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
                          <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{item.title}</h3>
                          <p className="text-foreground-600 text-xs">{item.desc}</p>
                        </div>
                      ) : null}
                    </div>
                    <div className="md:hidden ml-12 bg-background-50 border border-background-200/70 rounded-xl p-4">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-heading font-bold text-primary-600 text-sm">{item.year}</span>
                        <h3 className="font-heading font-semibold text-foreground-900 text-sm">{item.title}</h3>
                      </div>
                      <p className="text-foreground-600 text-xs">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">信誉保障</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">正规牌照</h3>
                <p className="text-foreground-600 text-xs">持有国际游戏运营牌照，合法合规经营</p>
              </div>
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-lock-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">数据加密</h3>
                <p className="text-foreground-600 text-xs">银行级SSL加密，保障用户信息安全</p>
              </div>
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-scales-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">公平公正</h3>
                <p className="text-foreground-600 text-xs">国际RNG认证，游戏结果公平透明</p>
              </div>
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-customer-service-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">全天候服务</h3>
                <p className="text-foreground-600 text-xs">7×24小时客服在线，3分钟快速响应</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">常见问题</h2>
            <div className="flex flex-col gap-3" itemScope itemType="https://schema.org/FAQPage">
              {faqs.map((faq, i) => (
                <details key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer font-medium text-foreground-900 text-sm md:text-base" itemProp="name">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-foreground-600 text-sm leading-relaxed" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <div itemProp="text">{faq.a}</div>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center">联系我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-phone-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">客服热线</h3>
                <p className="text-foreground-600 text-xs mb-2">7×24小时全天候服务</p>
                <strong className="text-primary-600 text-sm">400-888-9999</strong>
              </div>
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">电子邮箱</h3>
                <p className="text-foreground-600 text-xs mb-2">商务合作与投诉建议</p>
                <strong className="text-primary-600 text-sm">service@jiuyou.com</strong>
              </div>
              <div className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-message-2-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">在线客服</h3>
                <p className="text-foreground-600 text-xs mb-2">官网右下角在线咨询</p>
                <strong className="text-primary-600 text-sm">3分钟快速响应</strong>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <ScrollToTop />
    </main>
  );
}